export const DislikeThird = ({ width = 30, height = 31, fill = 'none' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 31"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4983 3.5C24.9835 3.5 26.9983 5.51472 26.9983 8V14C26.9983 16.4853 24.9835 18.5 22.4983 18.5H20.4703L18.6691 25.0125C17.9516 26.4473 16.5292 27.3848 14.9433 27.4901L14.6442 27.5H14.2483C12.26 27.5 10.6332 25.9527 10.5062 23.9966L10.4983 23.75V18.5H7.50087C7.20453 18.5 6.90893 18.4707 6.61835 18.4126C4.26836 17.9426 2.71483 15.7214 3.04389 13.3783L3.08825 13.1175L4.88825 7.11748C5.29141 5.10171 7.00437 3.6272 9.03437 3.50782L9.30087 3.5H22.4983ZM20.9983 15.5H22.4983C23.3267 15.5 23.9983 14.8284 23.9983 14V8C23.9983 7.17157 23.3267 6.5 22.4983 6.5H20.9983V15.5ZM14.2483 24.5H14.6442C15.0781 24.5 15.4835 24.3128 15.7641 23.9979L15.8764 23.8554L17.6316 17.505C17.6833 17.3179 17.7531 17.1363 17.8399 16.9626C17.918 16.8064 17.968 16.6382 17.9882 16.4656L17.9983 16.2918V6.5H9.21087C8.55543 6.5 7.98352 6.92408 7.78474 7.53481L7.67173 7.97952L5.92311 13.8083L5.91066 13.9862C5.90335 14.6927 6.39841 15.3272 7.11669 15.4709L7.26306 15.4927V15.4927L7.41087 15.5H10.4983C12.0798 15.5 13.3755 16.7238 13.49 18.2761L13.4983 18.5V23.75C13.4983 24.1182 13.7636 24.4244 14.1134 24.4879L14.2483 24.5Z"
        fill="white"
      />
    </svg>
  );
};
